export default import.meta.ROLLDOWN_FILE_URL_qqJRVEh6aGlxhf56pSYIBA